import {Component, Input, OnChanges, SimpleChanges, EventEmitter,Output} from '@angular/core';
import {TimeFormatPipe} from "../../pipes/time-format/time-format";
import {parseDate} from "ionic-angular/util/datetime-util";
declare var $: any;
/**
 * Generated class for the DalayTimerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'dalay-timer',
  templateUrl: 'dalay-timer.html'
})
export class DalayTimerComponent{

  @Input() delayObj;
  @Output('changeText') changeText = new EventEmitter();

  send_time_string;
  min:string;
  constructor() {
    console.log('Hello DalayTimerComponent Component');
    this.min = new TimeFormatPipe().transform(new Date().getTime(),'yyyy-MM-ddThh:mm');
    // parseDate()
  }

  ngOnChanges(changes:SimpleChanges){
    if(changes['delayObj'] && this.delayObj['delayToggle'] ){
      // this.send_time_string = new TimeFormatPipe().transform(this.delayObj['sendTime'],'yyyy-MM-ddHhh-mm');

      this.send_time_string = new Date((this.delayObj['send_time']*1000 + 8*60*60*1000)).toISOString();
    }
  }
  // delayToggle:boolean;

  switch(){
    this.delayObj.delayToggle = !this.delayObj.delayToggle;
    this.changeText.emit(this.delayObj.delayToggle);
    if(this.delayObj.delayToggle){
      setTimeout( () => {
        $('.time-picker button').click()
      })
    }
  }

  getSendTime(e){
    // 减八小时  转化成本地时间
    this.delayObj.send_time = new Date(e).getTime() - 8*60*60*1000;
  }


}



// WEBPACK FOOTER //
// ./src/components/dalay-timer/dalay-timer.ts